var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center text-caption"},[_c('v-icon',{class:{'mr-2': _vm.dense, 'mr-6': !_vm.dense}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }